/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_box_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The box edges are the first and third quartiles, the line inside is the median, and the whiskers extend to the minimum and maximum values.`)
};

const es_box_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los bordes de la caja son el primer y tercer cuartil, la línea interior es la mediana, y los bigotes se extienden hasta los valores mínimo y máximo.`)
};

const de_box_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Boxränder sind das erste und dritte Quartil, die Linie darin ist der Median, und die Whisker reichen bis zum Minimum und Maximum.`)
};

const nl_box_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De boxranden zijn het eerste en derde kwartiel, de lijn binnenin is de mediaan, en de whiskers reiken tot de minimum- en maximumwaarden.`)
};

const fr_box_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les bords de la boîte sont les premier et troisième quartiles, la ligne intérieure est la médiane, et les moustaches s'étendent jusqu'aux valeurs minimale et maximale.`)
};

const it_box_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I bordi della scatola sono il primo e il terzo quartile, la linea all'interno è la mediana, e i baffi si estendono fino ai valori minimo e massimo.`)
};

const pt_br2_box_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As bordas da caixa são o primeiro e o terceiro quartis, a linha interna é a mediana, e as hastes se estendem até os valores mínimo e máximo.`)
};

const pt_box_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os bordos da caixa são o primeiro e terceiro quartis, a linha no interior é a mediana, e as hastes estendem-se até aos valores mínimo e máximo.`)
};

const ja_box_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`箱の両端は第一四分位数と第三四分位数、内側の線は中央値、ひげは最小値と最大値まで伸びます。`)
};

const zh_box_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`箱体的两条边分别是第一和第三四分位数，内部的横线是中位数，须线延伸至最小值和最大值。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const box_faq_a2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.box_faq_a2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("box_faq_a2", locale)
	if (locale === "en") return en_box_faq_a2(inputs)
	if (locale === "es") return es_box_faq_a2(inputs)
	if (locale === "de") return de_box_faq_a2(inputs)
	if (locale === "nl") return nl_box_faq_a2(inputs)
	if (locale === "fr") return fr_box_faq_a2(inputs)
	if (locale === "it") return it_box_faq_a2(inputs)
	if (locale === "pt-BR") return pt_br2_box_faq_a2(inputs)
	if (locale === "pt") return pt_box_faq_a2(inputs)
	if (locale === "ja") return ja_box_faq_a2(inputs)
	return zh_box_faq_a2(inputs)
};